import { Feature } from 'geojson';
import constants from '../constants';
import { CircleDot } from '../styles/CircleDot';

export const labelToDot = (matchingLabel: string, objectClass: string | undefined = undefined): JSX.Element => {
    if (objectClass && (objectClass === 'platform' || objectClass === 'windmill')) {
        return <CircleDot {...constants.colors.markers.staticObjects} />;
    } else if (matchingLabel === 'undetected') {
        return <CircleDot {...constants.colors.markers.undetectedAis} />;
    } else if (matchingLabel === 'matched') {
        return <CircleDot {...constants.colors.markers.matchedVessels} />;
    } else if (matchingLabel === 'dark_vessel') {
        return <CircleDot {...constants.colors.markers.darkShips} />;
    }
    return <CircleDot {...constants.colors.markers.yellow} />;
};

export const getLegendDot = (feature: Feature): JSX.Element | undefined => {
    if (!feature.properties) return;
    return labelToDot(feature.properties.matching_label, feature.properties.object_class);
};
